module.exports = __webpack_public_path__ + "static/img/top_image_02.9a7cce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_image_02.png
// module id = A5IZ
// module chunks = 1